import { borderRadius } from "../borders";
import { background, blue, gray, red } from "../colors";

export const MuiTabs = {
  styleOverrides: {
    root: {
      backgroundColor: background.light,
      width: "max-content",
      padding: "2px",
      borderRadius: borderRadius.small,
      display: "flex",
      alignItems: "center",
      minHeight: "unset",
      "& .MuiTabs-indicator": {
        display: "none",
      },
    },
  },
};

export const MuiTab = {
  styleOverrides: {
    root: {
      fontWeight: 500,
      letterSpacing: "0.1rem",
      minWidth: 100,
      color: gray[80],
      paddingTop: "4px",
      paddingBottom: "4px",
      minHeight: "36px",
      width: "156px",
      // textTransform cases TS issues, but we are ignoring it
      textTransform: "none",
      "&.Mui-selected": {
        color: blue[100],
        backgroundColor: background.white,
        borderRadius: borderRadius.small,
        border: `0.25px solid ${gray[40]}`,
        "&.red": {
          color: red[100],
        },
      },
    },
  },
};
